import React from 'react';
const { Box, LinearProgress, Typography, Backdrop } = require('@mui/material');
const Loading = ({ text, imageSource = null, isLoading }) => {
    return (
        <Backdrop
                sx={(theme) => ({ 
                    bgcolor: 'rgba(0, 0, 0, 0.6)',
                    color: '#fff', 
                    zIndex: theme.zIndex.drawer + 1,
                    flexDirection: 'column',
                    gap: 3,
                    padding: 2,
                })}
                open={isLoading}
            >
                {imageSource && (
                    <img 
                    src={imageSource} 
                    width={"80px"}
                    alt="loading image"
                    />
                )}
                    <Typography variant="body">
                        {text}
                    </Typography>
                    <Box sx={{ width: { xs: '80%', md: '40%'} }}>
                        <LinearProgress color="inherit"/>
                    </Box>
            </Backdrop>
    )
}

export default Loading;